const combine = arr => {
  if (arr.length === 1) {
    return arr[0]
  }

  if (arr.length === 0) {
    return []
  }

  const result = []
  const rest = combine(arr.slice(1))
  rest.forEach(restValue => {
    arr[0].forEach(arrValue => {
      if (Array.isArray(restValue)) {
        result.push([arrValue, ...restValue])
      } else {
        result.push([arrValue, restValue])
      }
    })
  })
  return result
}

export const combineAttributes = attributes => {
  const filteredAttributes = attributes.filter(attribute => attribute.length > 0)
  return filteredAttributes.length === 1
    ? filteredAttributes[0].map(attribute => [attribute])
    : combine(filteredAttributes)
}

export const descriptionTranslate = description => {
  if (!description) {
    return ''
  }

  const lowerDesc = description.toLowerCase()
  const brDictionary = {
    adicional: 'additional',
    capacidade: 'capacity',
    cápsula: 'capsule',
    cor: 'color',
    lado: 'side',
    operador: 'operator',
    peça: 'piece',
    polegada: 'inch',
    quantidade: 'quantity',
    sabor: 'flavor',
    tamanho: 'size',
    voltagem: 'voltage',
  }

  return brDictionary[lowerDesc] || lowerDesc
}
